import React, { useState, useEffect, useRef } from "react";

function SCOTText(props) {
  const {
    label,
    name,
    id,
    fieldId,
    isRequired,
    errId,
    divClass,
    fieldName,
    handleTextChange,
    checkDetailsIndex,
    fieldValue,
    hasError = false,
  } = props;
  //Handling Initial States Floating Labels
  const [formData, setFormData] = useState({
    [name]: null,
  });

  //Handling Floating Labels
  const handleFloatingLabels = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));

    props.inputText([
      {
        name: name,
        value: e.target.value,
        fieldId: fieldId,
        isRequired: isRequired,
        err_id: errId,
      },
    ]);
  };

  let elementClass = "col-sm-4 col-md-12 col-xl-4";
  if (divClass) {
    elementClass = divClass;
  }

  const handleOnChange = (e) => {
    handleTextChange(e.target);
  };
  const errorMsg =
    (fieldValue == null || fieldValue == "") && isRequired == 1
      ? "This field is required."
      : "Please provide valid input";
  return (
    <>
      <div className={elementClass}>
        <div className="form-group">
          <div className="floating-label has-left-icon">
            <input
              type="text"
              className="form-control"
              name={name}
              id={id}
              value={fieldValue}
              onChange={(e) => handleOnChange(e)}
              data-checkdetailsindex={checkDetailsIndex}
              data-fieldname={fieldName}
              data-errorid = {errId}
            />
            <label
              htmlFor={props.id ? props.id : ""}
              className={fieldValue && "focused"}
            >
              {label}
              {isRequired == 1 && <sup className="text-danger">*</sup>}
            </label>
          </div>
          {hasError && hasError === true && (
            <p className="err text-danger" id={errId}>
              { errorMsg }
            </p>
          )}
        </div>
      </div>
    </>
  );
}

export default SCOTText;
